import React from 'react';
import { X } from 'lucide-react';

const Badge = ({
  children,
  variant = 'neutral',
  size = 'md',
  rounded = true,
  removable = false,
  onRemove,
  className = '',
  ...props
}) => {
  const baseStyles = 'inline-flex items-center gap-1 font-medium transition-all duration-200';

  const variants = {
    primary: 'bg-primary-100 text-primary-800 border border-primary-200',
    secondary: 'bg-secondary-100 text-secondary-800 border border-secondary-200',
    success: 'bg-success-100 text-success-800 border border-success-200',
    warning: 'bg-warning-100 text-warning-800 border border-warning-200',
    danger: 'bg-danger-100 text-danger-800 border border-danger-200',
    neutral: 'bg-neutral-100 text-neutral-800 border border-neutral-200',
    dark: 'bg-neutral-800 text-white border border-neutral-700',
  };

  const sizes = {
    xs: 'px-1.5 py-0.5 text-xxs',
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm',
  };

  const classes = [
    baseStyles,
    variants[variant] || variants.neutral,
    sizes[size] || sizes.md,
    rounded ? 'rounded-full' : 'rounded-md',
    className,
  ].filter(Boolean).join(' ');

  return (
    <span className={classes} {...props}>
      {children}
      {removable && (
        <button
          type="button"
          onClick={onRemove}
          className="ml-0.5 hover:bg-black/10 rounded-full p-0.5 transition-colors"
        >
          <X className="w-3 h-3" />
        </button>
      )}
    </span>
  );
};

export default Badge;
